"use client";
import InnerHTML from "dangerously-set-html-content";
import React from "react";
const InnerHTMLWithScript = (props) => {
	const { html } = props;
	
	return <InnerHTML html={html} />;
};


export default InnerHTMLWithScript;
